import CoreObject from "../foundation/core_object";

let Datastore = CoreObject.create({

});

export default Datastore;